module.exports = __webpack_public_path__ + "static/050b1948-f226-4d20-a65a-15d8ed031222-6aa6e18fe4f8fcaf8147e6196a2ed4f2.woff";